import axios from 'axios';
import { API_URL } from './config';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const auth = {
  signup: (data) => api.post('/api/auth/signup', data),
  login: (data) => api.post('/api/auth/login', data),
};

export const checkins = {
  create: (data) => api.post('/api/checkins', {
    ...data,
    timestamp: data.timestamp || new Date().toISOString(),
  }),
  getToday: () => api.get('/api/checkins/today'),
};

export const groups = {
  create: (data) => api.post('/api/groups', data),
  join: (code) => api.post('/api/groups/join', { code }),
  getMy: () => api.get('/api/groups/my'),
  getMembers: (groupId) => api.get(`/api/groups/${groupId}/members`),
};

export const support = {
  send: (data) => api.post('/api/support', data),
};

export const preferences = {
  get: () => api.get('/api/user/preferences'),
  update: (data) => api.put('/api/user/preferences', data),
};

export const alerts = {
  getUnread: () => api.get('/api/alerts'),
  markRead: (id) => api.put(`/api/alerts/${id}/read`),
};

export const admin = {
  getUsers: () => api.get('/api/admin/users'),
  getGroups: () => api.get('/api/admin/groups'),
  getAnalytics: () => api.get('/api/admin/analytics'),
  suspendUser: (id) => api.put(`/api/admin/users/${id}/suspend`),
  unsuspendUser: (id) => api.put(`/api/admin/users/${id}/unsuspend`),
};

export const user = {
  deleteAccount: () => api.delete('/api/user/account'),
};

export default api;
